import React from 'react';
import { ANREDEN } from '../types';
import { Select } from './ui';

/**
 * Auswahl der Anrede statt Freitext. Ein Altwert, der nicht in der Liste steht (früher frei
 * eingegeben), bleibt als eigene Option erhalten – sonst ginge er beim Speichern stillschweigend verloren.
 */
const AnredeSelect: React.FC<{ value: string; onChange: (anrede: string) => void }> = ({ value, onChange }) => {
  const altwert = value && !(ANREDEN as readonly string[]).includes(value) ? value : null;
  return (
    <Select value={value} onChange={e => onChange(e.target.value)}>
      <option value="">–</option>
      {ANREDEN.map(a => <option key={a} value={a}>{a}</option>)}
      {altwert && <option value={altwert}>{altwert}</option>}
    </Select>
  );
};

export default AnredeSelect;
